// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5300":"e0f54eccf95b7f92","7594":"f1296be6969a43b8"}[chunkId] + ".css";
};